// src/firestore/users/userCardPacks/index.ts

import * as users from '../../users'
import * as path from '../../path'
import { firestore } from '../../../helpers/firebase/firestore'

/**
 * Path to the `userCardPacks` collection under a user.
 *
 * `users/{userId}/userCardPacks`
 */
export function collectionPath(userId: string): string {
  return path.append(users.documentPath(userId), 'userCardPacks')
}

/**
 * Path to a specific card pack document.
 *
 * `users/{userId}/userCardPacks/{packId}`
 */
export function documentPath(userId: string, packId: string): string {
  return path.append(collectionPath(userId), packId)
}

/**
 * A Firestore document representing a user card pack purchase.
 */
export type UserCardPack = {
  /** Unique identifier for the user card pack (same as docId) */
  userCardPackId: string
  /** Reference to the cardPack definition (cardPackId from `cardPacks` collection) */
  cardPackId: string
  /** Category (duplicate from cardPacks for easier querying) have to be consistency with cardPacks info */
  category: string
  /** Collection name (duplicate from cardPacks for easier querying) have to be consistency with cardPacks info*/
  collection: string
  /** Subcollection name (duplicate from cardPacks for easier querying) have to be consistency with cardPacks info*/
  subcollection?: string
  /** Timestamp when the pack was purchased */
  purchasedAt: firestore.Timestamp
  /** Timestamp when the pack was opened */
  openedAt?: firestore.Timestamp
  /** Array of `userCardId`s representing cards received from this pack */
  cardsReceived: string[]
  /** Total TON spent on this pack */
  amountSpent: number
  /** orderNo point to processedOrder */
  orderNo: string
}
